/* ══════════════════════════════════════════════════════════════════
   GK Globe — Orbit 3.1b. Globe dot-matrix berputar di latar hero.
   Canvas 2D + vanilla JS, nol library (pendekatan ala Stripe/GitHub
   globe, tanpa WebGL). Data daratan = bitmask grid 320x160 (base64)
   hasil rasterisasi Natural Earth; gold = submask bbox Indonesia.
   Density diratakan runtime dengan bobot cos(lat).
   Rotasi penuh 150 dtk, loop matematis tanpa jahitan. Hormati
   prefers-reduced-motion (frame statis menghadap Indonesia), pause
   saat offscreen / tab hidden. Kota berkedip dibaca dari atribut
   data-gk-globe-cities (baris "Nama,lat,lng").
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var LAND =
    'AAAAAAAAABgAAPsAAAf////8AAAAAAAAAAB4AAAH///AAAAAAAAAAAAAAAAAAD+AY94i4AAD/////AAAAAAAAAAA4AAA////' +
    '/4IABgAAAAAAAAAAAAB9+sfY/wAAAf////AAAAAAAAAAAcAHoP//////4A4AAAAAAAAAAAAAe//h2P/8AAP////wAAAAAAAA' +
    'AAOABy///////+QP/AAAAAAAP4AAAAH/8Dz//4AAv///2AAAAAAH4AAA4B+////////////4AAAAAf//wB8A//zcC7/wAf//' +
    '/+AAAAAAf+gAAAAPv////////////AHQAAf//////x8YL48P4AA///+AAAAAAf//gAAD55/////////////9/+AH///////A' +
    '+P/eCfwAf//gAAAAAAf///GH//+f///////////////wAf///////////gH+AP//wAAAAAAP///5H///P///////////////' +
    '/43///////////AD94D//wAZ4AAAH//+J////////////////////x4P///////////4H/AAP/AAD/AAAD/h/g//////////' +
    '//////////8AAH//////////3gH8AD/wAA/AAAB/5/9////////////////////8AMH//////////ggA/AAf4AAAAAAB/5//' +
    '/////////////////////gAH//////////wGEhgAD8AAAAAAB/8f////////////////////v/gAD//////////4AB8AAA/A' +
    'AAAAAAf+H///////////////////4z/AAAf/8///////8AAfwAABwAAAAAAH/w9//////////////////8D/AAAA/mAP////' +
    '//AAH8IAAAAAAAAAB/8Cf/////////////////uBgAAAAC4AB//////4AB/nAAAAAAAAAAc+B/////////////////wABwAA' +
    'AAANgAB//////AAP/4AAAAAAABQAPoP////////////////wAB+AAAAAMAAAP/////+AD/+AAAAAAAAcAZwf////////////' +
    '////4AAfgAAAAOAAAB//////4B//wAAAAAAAHAG4H////////////////8AAPwAAAAIAAAAP//////4///gAAAAAAG4AgD//' +
    '//////////////8AAD8AAAAAAAAAJ//////+P//4AAAAAAHnAPf/////////////////2AA8AAAAAAAAACf//////j///AAA' +
    'AAAAzw////////////////////4AGAAAAAAAAAAD//////8///wAAAAAAZ+P///////////////////+ABgAAAAAAAAAAf//' +
    '///////0AAAAAAAPv///////////////////+wAAAAAAAAAAAAN////////4xAAAAAAAEH////////////////////sAAAAA' +
    'AAAAAAAA////////4I8AAAAAAAP////////////////////6AAAAAAAAAAAAAF///////9wPgAAAAAAP////////////////' +
    '////8gAAAAAAAAAAAAA///////+8AIAAAAAAA////////////////////+IAAAAAAAAAAAAAP////////4AAAAAAAAH////u' +
    'P/H////////////jAAAAAAAAAAAAAD/////////AAAAAAAAB/+//xn/B////////////wAAAAAAAAAAAAAA////////2AAAA' +
    'AAAAAf/n/8A/w////////////4IAAAAAAAAAAAAAP///////xAAAAAAAAEP8c/+AH8f///////////8DgAAAAAAAAAAAAH//' +
    '/////4AAAAAAAAD/4Dj/gAfB///////////4DwAAAAAAAAAAAAA////////AAAAAAAAA/8Acf4cH4P//////////4AgAAAAA' +
    'AAAAAAAAP//////+AAAAAAAAAP+Bh3k///D//////////+AMAAAAAAAAAAAAAD///////AAAAAAAAAD/AYIw///x////////' +
    '/82ADAAAAAAAAAAAAAA///////gAAAAAAAAA/wACMP//8P////////+BwAwAAAAAAAAAAAAAH//////wAAAAAAAAAP4AHBj/' +
    '//D/////////geAIAAAAAAAAAAAAAB//////8AAAAAAAAAC8BoQQ///4//////////hgeAAAAAAAAAAAAAAP//////gAAAAA' +
    'AAAAAP+AAAD////////////g4HgAAAAAAAAAAAAAB//////wAAAAAAAAAD//wAIE////////////wOP4AAAAAAAAAAAAAAP/' +
    '////4AAAAAAAAAA//4AAAP///////////+AMwAAAAAAAAAAAAAAA/////8AAAAAAAAAA///AAAH////////////gGAAAAAAA' +
    'AAAAAAAAAP////8AAAAAAAAAAP//+DgB////////////8AgAAAAAAAAAAAAAAADf////AAAAAAAAAAH///w/Ef//////////' +
    '//AIAAAAAAAAAAAAAAAAT////wAAAAAAAAAB///////////////////wAAAAAAAAAAAAAAAAAG//8YMAAAAAAAAAAf//////' +
    '/+f/////////8AAAAAAAAAAAAAAAAAAn/+ABAAAAAAAAAAP////////n//////////AAAAAAAAAAAAAAAAAAM//AA4AAAAAA' +
    'AAAP//////3/4//////////gAAAAAAAAAAAAAAAAABv/gAGgAAAAAAAAD//////8//if////////4AAAAAAAAAAAAAAAAAAJ' +
    '/8ABgAAAAAAAAB///////n/8H////////8AAAAAAAAAAAAAAAAAADP+AACAAAAAAAAAf//////5//EAP///////AAAAAAAAA' +
    'AAAAAAAAAAR/gAAAAAAAAAAAP///////P//gD///////kAAAAAAAAAAAAAAAAAACP4ADgAAAAAAAAH///////x//+Af/////' +
    '/hAAAAAAAAAAAAAAAAAAAD+AAOAAAAAAAAB///////+f//gD//8///gAAAAAAAAAAAAIAAAAAAA/wOA4AAAAAAAAf///////' +
    'n//wA3/4P/5AAAAAAAAAAAAABAAAAAAAP8DAHAAAAAAAAD///////4//4AB/+B/8AAAAAAAAAAAAAAQAAAAAAB/BwAHAAAAA' +
    'AAA///////+P/+AAf+Af/EAAAAAAAAAAAAAAAAAAAAAP/8AzzAAAAAAAP///////x//AAH/gD/wAGAAAAAAAAAAAAAAAAAAA' +
    'A//AAAAAAAAAAD///////8P/gAB/wA/+ABgAAAAAAAAAAAAAAAAAAAD/gAAAAAAAAAB////////j/gAAf4AN/wAYAAAAAAAA' +
    'AAAAAAAAAAAAB/gAAAAAAAAAf///////4/wAAD4AAf+AEAAAAAAAAAAAAAAAAAAAAAP8AAAAAAAAAH////////vwAAA+AAH/' +
    'gAAAAAAAAAAAAAAAAAAAAAAA/AAAAAAAAAB////////7wAAAPgAB/4AEAAAAAAAAAAAAAAAAAAAAADwAAAAAAAAAf///////' +
    '/AAAAB4AAL+AEAAAAAAAAAAAAAAAAAAAAAAcAYAAAAAAAD////////wAAAAeAACfgAkAAAAAAAAAAAAAAAAAAAAADAdgQAAA' +
    'AAAf///////+eAAADgAADwAMAAAAAAAAAAAAAAAAAAAAAAwHf4AAAAAAD/////////gAAAwAAAYARAAAAAAAAAAAAAAAAAAA' +
    'AAACr//AAAAAAA/////////4AAANAAGEAIEAAAAAAAAAAAAAAAAAAAAAAb//4AAAAAAP////////8AAAAYAAgAAHAAAAAAAA' +
    'AAAAAAAAAAAAAAAf//AAAAAAB/////////AAAAGAAEAACwAAAAAAAAAAAAAAAAAAAAAAH//4AAAAAAP/j//////wAAABAABg' +
    'AYEAAAAAAAAAAAAAAAAAAAAAAB///4AAAAAA9gf/////4AAAAAAGcAPAAAAAAAAAAAAAAAAAAAAAAAAf///AAAAAAAAA////' +
    '/8AAAAAABnAHgAAAAAAAAAAAAAAAAAAAAAAAH///4AAAAAAAAH/////AAAAAAAMwBwAAAAAAAAAAAAAAAAAAAAAAAD///+AA' +
    'AAAAAAB/////gAAAAAABkB+AAAAAAAAAAAAAAAAAAAAAAAA////wAAAAAAAA/////wAAAAAAAOh/gEAAAAAAAAAAAAAAAAAA' +
    'AAAAf///4AAAAAAAAP////4AAAAAAADwf55AAAAAAAAAAAAAAAAAAAAAAP////gAAAAAAAD////8AAAAAAAAcH8gAAAAAAAA' +
    'AAAAAAAAAAAAAAD/////AAAAAAAA////+AAAAAAAAHg/KA4AAAAAAAAAAAAAAAAAAAAA/////wAAAAAAAH////AAAAAAAAA4' +
    'PzAAcAAAAAAAAAAAAAAAAAAAAH/////4AAAAAAB////wAAAAAAAAHBY4s/4AAAAAAAAAAAAAAAAAAAD//////AAAAAAAP///' +
    '4AAAAAAAABwAKAD/gAAAAAAAAAAAAAAAAAAA//////8AAAAAAB///+AAAAAAAAAMACAAP8JAAAAAAAAAAAAAAAAAAP//////' +
    'gAAAAAAf///AAAAAAAAAAwAAAR/kAAAAAAAAAAAAAAAAAAB//////4AAAAAAH///4AAAAAAAAAHwAAAf4BAAAAAAAAAAAAAA' +
    'AAAAf/////+AAAAAAA///+AAAAAAAAAAPAAAHzAEAAAAAAAAAAAAAAAAAD//////gAAAAAAP///gAAAAAAAAAACBAAYwAAAA' +
    'AAAAAAAAAAAAAAA//////wAAAAAAD///4AAAAAAAAAAAIgAAGAIAAAAAAAAAAAAAAAAAH/////4AAAAAAA////AAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAB/////+AAAAAAAP///wAAAAAAAAAAAAAgIAAAAAAAAAAAAAAAAAAAAP/////AAAAAAAD///' +
    '8BAAAAAAAAAAAA/CAAAAAAAAAAAAAAAAAAAAD/////gAAAAAAB////AQAAAAAAAAAAAfgwAAAAAAAAAAAAAAAAAAAA/////4' +
    'AAAAAAAf///wOAAAAAAAAAAA3wOAAAAAAAAAAAAAAAAAAAAH////+AAAAAAAH///8HgAAAAAAAAAAf+DgAAIAAAAAAAAAAAA' +
    'AAAAAf////gAAAAAAD///+HwAAAAAAAAAAP/44AAAAEAAAAAAAAAAAAAAAD////4AAAAAAA////B8AAAAAAAAAAH//fAAAAA' +
    'AAAAAAAAAAAAAAAAf///+AAAAAAAH///gfAAAAAAAAAAB///wAAAAAAAAAAAAAAAAAAAAD////gAAAAAAB///wHwAAAAAAAA' +
    'AA///+AAAAAAAAAAAAAAAAAAAAA////wAAAAAAAP//4B4AAAAAAAAAA////wAAAAAAAAAAAAAAAAAAAAP///8AAAAAAAD//+' +
    'AeAAAAAAAAAB////+AAgAAAAAAAAAAAAAAAAAD///+AAAAAAAAf//gPgAAAAAAAAA/////gAAAAAAAAAAAAAAAAAAAA////g' +
    'AAAAAAAH//8BwAAAAAAAAAf////8AAAAAAAAAAAAAAAAAAAAf//+AAAAAAAAB///AcAAAAAAAAAH/////gAAAAAAAAAAAAAA' +
    'AAAAAH///AAAAAAAAAf//AHAAAAAAAAAB/////8AAAAAAAAAAAAAAAAAAAB///gAAAAAAAAH//gAAAAAAAAAAAP/////AAAA' +
    'AAAAAAAAAAAAAAAAf//4AAAAAAAAB//4AAAAAAAAAAAH/////wAAAAAAAAAAAAAAAAAAAH//+AAAAAAAAAP/+AAAAAAAAAAA' +
    'B/////8AAAAAAAAAAAAAAAAAAAB///gAAAAAAAAB//gAAAAAAAAAAAP/////AAAAAAAAAAAAAAAAAAAAf//wAAAAAAAAAf/w' +
    'AAAAAAAAAAAD/////wAAAAAAAAAAAAAAAAAAAP//4AAAAAAAAAH/4AAAAAAAAAAAA/////8AAAAAAAAAAAAAAAAAAAD//+AA' +
    'AAAAAAAA/8AAAAAAAAAAAAH/////AAAAAAAAAAAAAAAAAAAA///AAAAAAAAAAP/AAAAAAAAAAAAB/wH//wAAAAAAAAAAAAAA' +
    'AAAAAP//gAAAAAAAAAD/AAAAAAAAAAAAAfwA3/4AAAAAAAAAAAAAAAAAAAD//wAAAAAAAAAAYAAAAAAAAAAAAAPAAL/8AAAA' +
    'AAAAAAAAAAAAAAAA//gAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/AAAIAAAAAAAAAAAAAAAAf/4AAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAD/gAAAAAAAAAAAAAAAAAAAH/+AAAAAAAAAAAAAAAAAAAAAAAAAAAAA/4AAAQAAAAAAAAAAAAAAAB//gAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAH8AAAHgAAAAAAAAAAAAAAAf/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAAAAAAAAAAAAAAAH/gAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAAAAAAAAAAAAAAAD/4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASAAAAAAAAAAA' +
    'AAAAA/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAAGAAAAAAAAAAAAAAAAP+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAADA' +
    'AAAAAAAAAAAAAAAB/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAABwAAAAAAAAAAAAAAAA/wAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAABwAAAAAAAAAAAAAAAAPwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8AAAAAAAAAAAAAAAAH8AAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAGAAAAAAAAAAAAAAAAA/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf4AAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH8AAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAB+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAH4BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAFwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/AAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAHAAAAAABgMAACAAAAAAAAAAAAAAAAA' +
    'AAAAAA4AAAAAAAAAAAAAAAAH8AAABgB//4///8AAAAAAAAAAAAAAAAAAAAAMAAAAAAAAAAAAAAAA//74AP/////////gAAAA' +
    'AAAAAAAAAAAAAAAATgAAAAAAAAAAAAACD////AP//////////8AAAAAAAAAAAAAAAAAAAN8AAAAAAAAAAAAAH/////g/////' +
    '///////8AAAAAAAAAAAAAAAAAADvgAAAAAAAAA/////////4f/////////////AAAAAAAAAAAAAAAAAH74AAAAAAA///////' +
    '////+P//////////////AAAAAAAAAAAAAAAAAA/AAAAAAA///////////////////////////gAAAAAAAAGYAA/f/OH/wAAA' +
    'AAA///////////////////////////4AAAAAAAH///AD/////wAAAAAAP//////////////////////////gAA==';
  var GOLD =
    'wAAAAADAACAAAGAAIAAAMABwAAAcCXAIAB4P88gADg/kAAAPB+UBwAcH5gAOA4LHFn8DgAUAHwGABAAHAGAAACMAPgAAAwAH' +
    'gAADAAAQAAAAAARAAA==';
  var GW = 320, GH = 160, GR0 = 74, GC0 = 245, GBH = 17, GBW = 40;
  var D2R = Math.PI / 180;

  function bit(bin, i) { return (bin.charCodeAt(i >> 3) >> (7 - (i & 7))) & 1; }

  function buildPoints() {
    var lb = atob(LAND), gb = atob(GOLD), pts = [];
    for (var i = 0; i < GW * GH; i++) {
      if (!bit(lb, i)) continue;
      var col = i % GW, row = (i / GW) | 0;
      var lat = 75 - 150 * (row + 0.5) / GH;
      var lng = -180 + 360 * (col + 0.5) / GW;
      /* Pemerataan density: grid equirect oversample lintang tinggi.
         Seleksinya pakai hash pseudo-random per sel, BUKAN pola linear,
         karena pola linear bikin garis moire diagonal di benua. */
      var keep = Math.max(Math.cos(lat * D2R), 0.2);
      var hsh = Math.sin(col * 127.1 + row * 311.7) * 43758.5453;
      hsh -= Math.floor(hsh);
      if (hsh > keep) continue;
      var g = 0;
      if (row >= GR0 && row < GR0 + GBH && col >= GC0 && col < GC0 + GBW) {
        g = bit(gb, (row - GR0) * GBW + (col - GC0));
      }
      var la = lat * D2R, lo = lng * D2R;
      pts.push({
        x: Math.cos(la) * Math.cos(lo),
        y: Math.sin(la),
        z: Math.cos(la) * Math.sin(lo),
        g: g
      });
    }
    return pts;
  }

  function parseCities(txt) {
    var out = [];
    (txt || '').split(/\n+/).forEach(function (line, i) {
      var p = line.split(',');
      if (p.length < 3) return;
      var lat = parseFloat(p[1]), lng = parseFloat(p[2]);
      if (isNaN(lat) || isNaN(lng)) return;
      var la = lat * D2R, lo = lng * D2R;
      out.push({
        x: Math.cos(la) * Math.cos(lo),
        y: Math.sin(la),
        z: Math.cos(la) * Math.sin(lo),
        ph: i * 0.73
      });
    });
    return out;
  }

  function initGlobe(host) {
    var canvas = host.querySelector('canvas');
    if (!canvas) { canvas = document.createElement('canvas'); host.appendChild(canvas); }
    var ctx = canvas.getContext && canvas.getContext('2d');
    if (!ctx) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pts = buildPoints();
    var cities = parseCities(host.getAttribute('data-gk-globe-cities'));

    var S = 0, dpr = 1, R = 0, CX = 0, CY = 0;
    function resize() {
      var r = host.getBoundingClientRect();
      S = Math.max(r.width, 10);
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(S * dpr);
      canvas.height = Math.round(S * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      R = S * 0.455; CX = S / 2; CY = S / 2;
    }

    var TILT = 14 * D2R, ct = Math.cos(TILT), st = Math.sin(TILT);
    var PERIOD = 150000;
    var ROT0 = 28 * D2R; /* mulai menghadap Indonesia (lng ~118E) */

    function render(rot, tsec) {
      var cr = Math.cos(rot), sr = Math.sin(rot);
      ctx.clearRect(0, 0, S, S);
      /* Ocean: lebih terang dari background, meleleh ke transparan di tepi */
      var grad = ctx.createRadialGradient(CX, CY, 0, CX, CY, R * 1.02);
      grad.addColorStop(0, 'rgba(255,255,255,0.50)');
      grad.addColorStop(0.62, 'rgba(255,255,255,0.34)');
      grad.addColorStop(0.88, 'rgba(255,255,255,0.14)');
      grad.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = grad;
      ctx.beginPath(); ctx.arc(CX, CY, R * 1.02, 0, 6.2832); ctx.fill();
      /* Rim subtle: menyamar ke dalam dan ke luar */
      var rim = ctx.createRadialGradient(CX, CY, R * 0.90, CX, CY, R * 1.06);
      rim.addColorStop(0, 'rgba(194,183,168,0)');
      rim.addColorStop(0.58, 'rgba(194,183,168,0.15)');
      rim.addColorStop(0.68, 'rgba(194,183,168,0.17)');
      rim.addColorStop(1, 'rgba(194,183,168,0)');
      ctx.fillStyle = rim;
      ctx.beginPath(); ctx.arc(CX, CY, R * 1.06, 0, 6.2832); ctx.fill();

      var k = S / 660;
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i];
        var x = p.x * cr + p.z * sr, z = -p.x * sr + p.z * cr, y = p.y;
        var y2 = y * ct - z * st, z2 = y * st + z * ct;
        if (z2 <= 0.02) continue;
        var depth = z2, a, col, r;
        if (p.g) {
          /* Indonesia: gold bernafas antara gold-500 dan gold-light */
          var w = 0.5 + 0.5 * Math.sin(tsec * 1.256 + i * 0.9);
          col = Math.round(184 + 48 * w) + ',' + Math.round(134 + 51 * w) + ',' + Math.round(43 + 63 * w);
          a = (0.5 + 0.4 * depth) * (0.75 + 0.25 * w);
          r = (0.55 + 0.55 * depth) * k;
          var hx = CX - x * R, hy = CY - y2 * R;
          var halo = ctx.createRadialGradient(hx, hy, 0, hx, hy, 3.6 * k);
          halo.addColorStop(0, 'rgba(232,185,106,' + (0.3 * depth * (0.6 + 0.4 * w)).toFixed(3) + ')');
          halo.addColorStop(1, 'rgba(232,185,106,0)');
          ctx.fillStyle = halo;
          ctx.beginPath(); ctx.arc(hx, hy, 3.6 * k, 0, 6.2832); ctx.fill();
        } else {
          a = 0.10 + 0.32 * depth; col = '117,105,92';
          r = (0.38 + 0.47 * depth) * k;
        }
        ctx.fillStyle = 'rgba(' + col + ',' + a.toFixed(3) + ')';
        ctx.beginPath();
        ctx.arc(CX - x * R, CY - y2 * R, r, 0, 6.2832);
        ctx.fill();
      }
      /* Kota besar: padam-nyala gold */
      for (var c = 0; c < cities.length; c++) {
        var q = cities[c];
        var qx = q.x * cr + q.z * sr, qz = -q.x * sr + q.z * cr, qy = q.y;
        var qy2 = qy * ct - qz * st, qz2 = qy * st + qz * ct;
        if (qz2 <= 0.05) continue;
        var pulse = Math.pow(0.5 + 0.5 * Math.sin(tsec * 2.094 + q.ph * 6.283), 2);
        if (reduce) pulse = 0.55;
        var px = CX - qx * R, py = CY - qy2 * R;
        var chalo = ctx.createRadialGradient(px, py, 0, px, py, 6 * k);
        chalo.addColorStop(0, 'rgba(232,185,106,' + (0.5 * pulse * qz2).toFixed(3) + ')');
        chalo.addColorStop(1, 'rgba(232,185,106,0)');
        ctx.fillStyle = chalo;
        ctx.beginPath(); ctx.arc(px, py, 6 * k, 0, 6.2832); ctx.fill();
        ctx.fillStyle = 'rgba(203,160,67,' + (0.25 + 0.7 * pulse * qz2).toFixed(3) + ')';
        ctx.beginPath(); ctx.arc(px, py, (1.5 + 0.9 * pulse) * k, 0, 6.2832); ctx.fill();
      }
    }

    resize();
    if (reduce || !('requestAnimationFrame' in window)) {
      render(ROT0, 0);
      window.addEventListener('resize', function () { resize(); render(ROT0, 0); });
      return;
    }

    var visible = true, rafId = null;
    function frame(now) {
      rafId = null;
      if (!visible || document.hidden) return;
      render(ROT0 + (now % PERIOD) / PERIOD * 2 * Math.PI, now / 1000);
      rafId = requestAnimationFrame(frame);
    }
    function kick() {
      if (rafId === null && visible && !document.hidden) rafId = requestAnimationFrame(frame);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible = en.isIntersecting; kick(); });
      }, { threshold: 0 }).observe(host);
    }
    document.addEventListener('visibilitychange', kick);
    window.addEventListener('resize', function () { resize(); kick(); });
    kick();
  }

  var hosts = document.querySelectorAll('[data-gk-globe]');
  for (var h = 0; h < hosts.length; h++) initGlobe(hosts[h]);
})();
